import "../section/contact.css";
 
const title = (
    <h2 className="chalk-heading">
        Need Any <span>Help?</span>
    </h2>
);
 
const desc =
    "Feel free to reach out to us anytime. We are always here to help you with your learning needs.";
 
const contactInfoList = [
    { icon: "📞", subTitle: "Call Us At:", title: "+91 98765 43210" },
    { icon: "✉️", subTitle: "Email Us At:", title: "support@kalakakshaaha.com" },
];
 
const ContactInfo = () => {
    return (
        <section className="chalk-info-section">
            <div className="container text-center">
                {title}
                <p className="chalk-desc">{desc}</p>
 
                <div className="chalk-info-grid">
                    {contactInfoList.map((val, i) => (
                        <div className="chalk-info-box" key={i}>
                            <div className="chalk-info-icon">{val.icon}</div>
                            <h5>{val.subTitle}</h5>
                            <h3>{val.title}</h3>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
 
export default ContactInfo;